module.exports = __webpack_public_path__ + "img/cbd5a7a.png";